import { connect } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';

import { 
    getConstraintsList,
    getPhaseTags,
    isVarianceLogDialogOpen
} from '../../selectors/phaseplan.selector'

import {
    getLookaheadTags, getActiveCommitmentLog,getActiveCompeleteCommitmentLog, getLookaheadTrades
} from '../../selectors/lookahead.selector'

import { getProjectUsers } from '../../selectors/project.selector';
import { ThunkDispatch } from 'redux-thunk';
import { dialogActions } from '../../actions/dialog.actions';
import { withFirebase } from 'react-redux-firebase';
import { withRouter } from 'react-router';
import { getLocationPathName } from '../../selectors/util.selector';
import VarianceLogDialog from './VarianceLogDialog';


const mapStateToProps = (state: any) => ({
    constraintList: getConstraintsList(state),
    projectUsers: getProjectUsers(state),
    isVarianceLogDialogOpen: isVarianceLogDialogOpen(state),
    phaseTags: getPhaseTags(state),
    lookaheadTags: getLookaheadTags(state),
    pathName: getLocationPathName(state),
    commitmentLog: getActiveCompeleteCommitmentLog(state),
    trades: getLookaheadTrades(state)

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {

  return {
    closeDialogValue: () => dispatch(dialogActions.closeVarianceLogDialog()),
    openConstraintDialog: (constaintId?: string) => dispatch(dialogActions.openConstraintDialog(constaintId))
  }
};

export default compose(
  withRouter,
  withFirebase,
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(VarianceLogDialog);


// WEBPACK FOOTER //
// ./src/components/Dialogs/VarianceLogDialogContainer.ts